module.exports = __webpack_public_path__ + "img/telegram_logo.775e1fa0.png";